import { supabase } from './supabase';

export type CountMap = Record<string, number>;

const toMap = (rows: unknown): CountMap => {
  const map: CountMap = {};
  if (!Array.isArray(rows)) return map;
  for (const row of rows as { event_id?: string; count?: number | string }[]) {
    if (row?.event_id) map[row.event_id] = Number(row.count) || 0;
  }
  return map;
};

export const fetchSignupCounts = async (
  eventIds: string[]
): Promise<{ volunteers: CountMap; attendees: CountMap }> => {
  if (eventIds.length === 0) return { volunteers: {}, attendees: {} };

  const [vol, att] = await Promise.all([
    supabase.rpc('get_volunteer_counts', { event_ids: eventIds }),
    supabase.rpc('get_attendee_counts', { event_ids: eventIds }),
  ]);

  if (vol.error) console.error('Error fetching volunteer counts:', vol.error);
  if (att.error) console.error('Error fetching attendee counts:', att.error);

  return { volunteers: toMap(vol.data), attendees: toMap(att.data) };
};
